import { utils } from '@hh/global.js'

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    this.consentGiven = false
    this.consentCheckAttempts = 0
    this.maxConsentCheckAttempts = 5
    this.oneTrustListenerSetup = false
    this.isExternalVideo = this.hasAttribute('data-external-video')
    
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      'click',
      this.handlePlayClick.bind(this)
    )
  }

  connectedCallback() {
    if (this.isExternalVideo) {
      this.checkConsent()
      this.setupDelayedConsentCheck()
      this.updateConsentUI()
    } else {
      this.consentGiven = true
    }
  }

  setupDelayedConsentCheck() {
    if (!this.isExternalVideo || this.consentGiven) return

    setTimeout(() => {
      if (!this.consentGiven && this.consentCheckAttempts < this.maxConsentCheckAttempts) {
        this.consentCheckAttempts++
        this.checkConsent()
        
        if (this.isExternalVideo && window.OneTrust && !this.oneTrustListenerSetup) {
          this.oneTrustListenerSetup = true
          window.OneTrust.OnConsentChanged(() => {
            this.checkConsent()
            this.updateConsentUI()
          })
        }

        if (!this.consentGiven) {
          this.setupDelayedConsentCheck()
        }
        this.updateConsentUI()
      }
    }, 1000)
  }

  checkConsent() {
    if (!this.isExternalVideo) {
      this.consentGiven = true
      return
    }

    if (typeof window !== 'undefined' && window.OneTrust) {
      const activeGroups = window.OnetrustActiveGroups
      this.consentGiven = activeGroups.includes('C0003') || activeGroups.includes('C0004')
    } else {
      this.consentGiven = false
    }
  }

  updateConsentUI() {
    const consentOverlay = this.querySelector('.video-consent-overlay')
    const posterButton = this.querySelector('[id^="Deferred-Poster-"]')
    
    if (this.isExternalVideo && !this.consentGiven) {
      if (!consentOverlay) {
        this.createConsentOverlay()
      }
      if (posterButton) {
        posterButton.style.display = 'none'
      }
    } else {
      if (consentOverlay) {
        consentOverlay.remove()
      }
      if (posterButton) {
        posterButton.style.display = ''
      }
    }
  }

  createConsentOverlay() {
    const consentMessage = window.themeStrings?.video?.consent?.message || 
      "This video is hosted by YouTube and requires cookies to play. Please accept Functional or Marketing cookies to view this content."
    const consentButton = window.themeStrings?.video?.consent?.button || 
      "Accept cookies and play video"

    const overlay = document.createElement('div')
    overlay.className = 'video-consent-overlay'
    overlay.innerHTML = `
      <div class="video-consent-content">
        <div class="video-consent-message">
          <p>${consentMessage}</p>
        </div>
        <button class="video-consent-button" type="button">
          ${consentButton}
        </button>
      </div>
    `

    const consentBtn = overlay.querySelector('.video-consent-button')
    consentBtn.addEventListener('click', this.handleConsentClick.bind(this))

    this.appendChild(overlay)
  }

  handleConsentClick() {
    if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
      window.OneTrust.ToggleInfoDisplay()
    }
  }

  handlePlayClick() {
    if (this.isExternalVideo && !this.consentGiven) {
      this.handleConsentClick()
      return
    }
    
    this.loadContent()
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)

      utils.pauseAllMedia()

      this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      ).focus()
    }
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', DeferredMedia);
}